import CreateInvestmentError from './CreateInvestmentError';
class BrickNumberIsUnderMinimumBricks extends CreateInvestmentError {
    constructor(options) {
        super('The number of bricks purchased is less than the minimum number of bricks', options);
    }
}
export default BrickNumberIsUnderMinimumBricks;
